function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};

var _ShapeManager_engine;

var shapes = new Map();
export var ShapeManager = /*#__PURE__*/function () {
  function ShapeManager(engine) {
    _classCallCheck(this, ShapeManager);

    _ShapeManager_engine.set(this, void 0);

    __classPrivateFieldSet(this, _ShapeManager_engine, engine, "f");
  }

  _createClass(ShapeManager, [{
    key: "addShape",
    value: function addShape(name, drawer) {
      if (!this.getShape(name)) {
        shapes.set(name, drawer);
      }
    }
  }, {
    key: "getShape",
    value: function getShape(name) {
      return shapes.get(name);
    }
  }, {
    key: "getSupportedShapes",
    value: function getSupportedShapes() {
      return shapes.keys();
    }
  }]);

  return ShapeManager;
}();
_ShapeManager_engine = new WeakMap();